var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PracticeChooseModePopup',{attrs:{"visible":_vm.practiceChooseModePopupVisible},on:{"update:visible":function($event){_vm.practiceChooseModePopupVisible=$event},"confirm":function($event){return _vm.goAnswerRequest({
        practiceMode: $event === 'practice' ? 0 : 1,
        ..._vm.currentPractice,
      })},"cancel":function($event){return _vm.goHome('')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }